import * as React from 'react'

export default function NotFound() {
  return (
    <div>
      Not Found
    </div>
  )
}



// WEBPACK FOOTER //
// ./client/NotFound.tsx